import url from "url";
import Cookie from "js-cookie";
import { ORGANIC_REFERRER } from "@/constants/cookieAndLsName";

const setReferrer = () => {
  const referrer = document.referrer;
  // referrer 有值
  if (referrer) {
    try {
      let { hostname } = url.parse(referrer, true);
      hostname = hostname || "";
      // 非 webnovel.com 的域名才记录下来
      if (
        !(
          hostname.indexOf("chereads.com") + "chereads.com".length ===
          hostname.length
        )
      ) {
        Cookie.set(ORGANIC_REFERRER, hostname, {
          path: "/",
          domain: ".chereads.com",
          expires: 30,
        });
      }
    } catch (e: any) {
      console.log(e.toString());
    }
  }
};

const getReferrer = () => {
  return Cookie.get(ORGANIC_REFERRER) || "";
};

export { setReferrer, getReferrer };
